import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DispatchArticle } from './dispatch-planner-csv.service';
import { DispatchStop } from './dispatch-planner.component';

export interface DispatchPlannerArticlesDialogData {
  stop: DispatchStop;
  kostenBase?: number;
  distanceSurcharge?: number;
  kostenGesamt?: number;
}

@Component({
  selector: 'app-dispatch-planner-articles-dialog',
  templateUrl: './dispatch-planner-articles-dialog.component.html',
  styleUrls: ['./dispatch-planner-articles-dialog.component.css']
})
export class DispatchPlannerArticlesDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DispatchPlannerArticlesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DispatchPlannerArticlesDialogData
  ) {}

  get stop(): DispatchStop {
    return this.data.stop;
  }

  get articles(): DispatchArticle[] {
    return this.stop.articles || [];
  }

  formatCurrency(value: number | null | undefined): string {
    if (value == null || Number.isNaN(value)) {
      return '-';
    }
    return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  formatMenge(value: number | null | undefined): string {
    if (value == null || Number.isNaN(value)) {
      return '-';
    }
    return value.toLocaleString('de-DE', { maximumFractionDigits: 2 });
  }

  close(): void {
    this.dialogRef.close();
  }
}
